import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import LiveDashboard from './pages/LiveDashboard';
import KPIDashboard from './pages/KPIDashboard';
import Staffing from './pages/Staffing';
import Scheduling from './pages/Scheduling';
import ScheduleTemplates from './pages/ScheduleTemplates';
import ControlCenter from './pages/ControlCenter';
import Locations from './pages/Locations';
import Employees from './pages/Employees';
import Events from './pages/Events';
import EmployeePortal from './pages/EmployeePortal';
import Login from './pages/Login';
import './index.css';

function AppContent() {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in on mount
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  // Employee Portal - no authentication required
  if (location.pathname === '/employee-portal') {
    return (
      <Routes>
        <Route path="/employee-portal" element={<EmployeePortal />} />
      </Routes>
    );
  }

  // Login page - redirect to home if already logged in
  if (location.pathname === '/login') {
    return (
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} />
      </Routes>
    );
  }

  // Protected management routes - require authentication
  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <Layout user={user} onLogout={handleLogout}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/live" element={<LiveDashboard />} />
        <Route path="/kpi" element={<KPIDashboard />} />
        <Route path="/staffing" element={<Staffing />} />
        <Route path="/scheduling" element={<Scheduling />} />
        <Route path="/templates" element={<ScheduleTemplates />} />
        <Route path="/control" element={<ControlCenter />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/events" element={<Events />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;